"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliverableGenerateReceiptWorkleaseSchema = exports.DeliverablesCreateZipFilesWorkleaseSchema = exports.DeliverableContainerGenerateReceiptStatuses = exports.DAYS_BEFORE_DUE_DATE = exports.DeliverableContainerTypes = exports.DeliverableTypes = exports.v3DEPRECATED = exports.v2DEPRECATED = void 0;
const zod_1 = require("zod");
// Re-export deprecated namespaces as modules
exports.v2DEPRECATED = __importStar(require("./Deliverable/v2DEPRECATED"));
exports.v3DEPRECATED = __importStar(require("./Deliverable/v3DEPRECATED"));
// ___________ CONFIG TYPES ___________
exports.DeliverableTypes = [
    'monthlyServicerReportXlsx',
    'loanTape',
    'repaymentTape',
    'supplementalTape',
    'cashBalancesFeed',
    'portfolioCovenant',
    'orgProvidedInput', // 'other' type for special customer input
    'monthlyStatement',
    'financialStatement',
    'financialCovenant',
];
exports.DeliverableContainerTypes = [
    'settlementReport', // MSR (just removing the cadence)
    'borrowingBaseCertificate', // domain isn't supported yet
    'complianceCertificate', // domain isn't supported yet
    'financials', // domain isn't supported yet
    'budgetsAndProjections', // domain isn't supported yet
    'other', // domain isn't supported yet
];
exports.DAYS_BEFORE_DUE_DATE = 30;
// generate receipt table
exports.DeliverableContainerGenerateReceiptStatuses = [
    'initialized',
    'inProgress',
    'success',
    'error',
];
// Zod schema for DeliverablesCreateZipFilesWorklease
exports.DeliverablesCreateZipFilesWorkleaseSchema = zod_1.z.object({
    receiptId: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    creditFacilityId: zod_1.z.string(),
});
// Zod schema for DeliverableGenerateReceiptWorklease
exports.DeliverableGenerateReceiptWorkleaseSchema = zod_1.z.object({
    generateReceiptId: zod_1.z.string(),
});
//# sourceMappingURL=Deliverable.js.map